<template>
  <div class="h-tab-wrap" :class="$i18n.locale">
    <div :class="['iconfont', icon]"></div>
    <div class="content">
      <span class="label">{{ label }}:</span>
      <span class="value">{{ value }}</span>
      <span v-if="unit" class="unit">{{ unit }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    }
  }
};
</script>

<style lang="scss">
.h-tab-wrap {
  font-size: calc(var(--base-font-size) * 1.3);
  width: calc(var(--base-font-size) * 16.8);
  height: calc(var(--base-font-size) * 2.5);
  line-height: calc(var(--base-font-size) * 2.5);

  // background: url('~@/assets/image/customs/x1.png');

  // background-size: 100% 100%;
  // background-repeat: no-repeat;
  color: #000;

  display: flex;
  align-items: center;

  position: relative;

  &::after {
    content: '';

    background: url('~@/assets/image/customs/x1.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    backdrop-filter: blur(10px);
    z-index: -1;
  }

  .iconfont {
    margin: 0 8px 0 12px;
    font-size: calc(var(--base-font-size) * 1.45);
  }

  &.en {
    width: 250px;
  }

  &.ar {
    width: 186px;
  }

  &.es {
    width: 280px;
  }

  &.fr {
    width: 260px;
  }

  &.ru {
    width: 284px;
  }

  .content {
    .label {
      margin-right: 4px;
      display: inline-block;
      width: calc(var(--base-font-size) * 9.8);
      text-align-last: justify;
    }

    .unit {
      margin-left: 2px;
    }
  }
}
</style>
